/**
 * BloxFinder - Join Anyone on Roblox
 *
 * Exposes `images/*`, `storage/*` and locale JSON as static web-accessible resources,
 * scoped to `*.roblox.com`. Detectable only from Roblox, where it runs, via one
 * CORS-free image load.
 *
 * Manifest verified against version 26.1.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'bnpkdbbfehooennlcojneoimfjgekdgn';

export const bloxfinder: ExtensionDefinition = {
  id: ID,
  name: 'BloxFinder - Join Anyone on Roblox',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  requiredOrigin: 'https://www.roblox.com',
  notes:
    'Images are static WAR scoped to *.roblox.com, so only Roblox can detect it. Loads ' +
    'as an image without a CORS grant.',
  signals: [
    {
      id: 'war-icon16',
      kind: 'web-accessible-resource',
      description:
        'Load images/icon16.png via <img> — a bundled icon exposed only to roblox.com origins.',
      weight: 1,
      run: () => probeImage(ID, 'images/icon16.png'),
    },
  ],
};
